export default {"src":"/_next/static/media/Line 1322.686faffa.svg","height":73,"width":11,"blurWidth":0,"blurHeight":0};